import { getFragmentData, type FragmentType } from '@packages/gql/generated/shopping';
import { ArticleServicesClusterFragmentFragmentDoc } from '@packages/gql/generated/shopping/ArticleServicesClusterFragmentFragmentDoc';
import { Stack, Typography } from '@packages/shared';
import type { ArticleServicesCurrencyFragmentFragmentDoc } from '@packages/gql/generated/shopping/ArticleServicesCurrencyFragmentFragmentDoc';
import { ArticleServicesServiceFragmentFragmentDoc } from '@packages/gql/generated/shopping/ArticleServicesServiceFragmentFragmentDoc';
import { ArticleServicesService } from '../ArticleServicesService';

/* GraphQL */ `
  fragment ArticleServicesClusterFragment on Cluster {
    label
    services {
      ...ArticleServicesServiceFragment
    }
  }
`;
export type ArticleServicesClusterProps = {
  data: FragmentType<typeof ArticleServicesClusterFragmentFragmentDoc>;
  /* should be in aPlus price value */
  currencyData: FragmentType<typeof ArticleServicesCurrencyFragmentFragmentDoc>;
};

export const ArticleServicesCluster = ({ data, currencyData }: ArticleServicesClusterProps) => {
  const { label, services } = getFragmentData(ArticleServicesClusterFragmentFragmentDoc, data);

  return (
    <Stack component="fieldset" sx={{ border: 'none', p: 0, m: 0 }} gap={1}>
      <div>
        <Typography
          component="legend"
          variant="body3"
          fontWeight="fontWeightSemiBold"
          textTransform="uppercase"
          padding={0}
          display="block"
        >
          {label}
        </Typography>
      </div>
      {services.map((service) => {
        const { uuid } = getFragmentData(ArticleServicesServiceFragmentFragmentDoc, service);
        return <ArticleServicesService data={service} currencyData={currencyData} key={uuid} />;
      })}
    </Stack>
  );
};
